<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

// Estado de erro do relatório com ação de recarregar.
defineProps({
  message: { type: String, default: '' },
});

const emit = defineEmits(['retry']);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <div
    class="mx-auto grid max-w-xl place-items-center rounded-lais border border-lais-border-soft bg-white p-8 text-center shadow-sm"
  >
    <span
      class="i-lucide-bar-chart-3 size-10 text-lais-text-empty"
      aria-hidden="true"
    />
    <h2
      class="mt-4 font-redHatDisplay text-[20px] font-semibold text-lais-text"
    >
      Ops... Relatório indisponível
    </h2>
    <p class="mt-2 text-[13px] leading-relaxed text-lais-text-body">
      {{ message }}
    </p>
    <LaisPrimaryButton
      class="mt-5"
      icon="i-lucide-refresh-cw"
      @click="emit('retry')"
    >
      Tentar novamente
    </LaisPrimaryButton>
  </div>
</template>
